exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n[data-v-5c992b5d] .v-alert {\n  padding: 0px !important;\n}\n.hide-block[data-v-5c992b5d] {\n  display: none;\n}\n", ""]);

// exports
